import { STATUS_LABELS, STATUS_COLORS } from "@/lib/constants";

export const StatusBadge = ({ status, className = "" }) => (
  <span
    data-testid={`status-badge-${status}`}
    className={`inline-flex items-center px-2.5 py-1 text-xs font-semibold uppercase tracking-wide border ${
      STATUS_COLORS[status] || "bg-zinc-100 text-zinc-700 border-zinc-300"
    } ${className}`}
  >
    {STATUS_LABELS[status] || status}
  </span>
);
